export type HostRequest = {method:string; path:string; params?:unknown; body?:unknown};
type Transport = (request:HostRequest)=>Promise<unknown>;
let transport: Transport | null = null;
const listeners=new Set<()=>void>();
export const isHostConnected=()=>transport!==null;
export function subscribeHostConnection(listener:()=>void){listeners.add(listener);return()=>{listeners.delete(listener);};}

/** Host-owned API integration only. The company API server is never a fallback. */
export function connectHostTransport(next: Transport) {
  transport = next;
  listeners.forEach(listener=>listener());
  return () => { if (transport === next) {transport = null;listeners.forEach(listener=>listener());} };
}
export async function requestHost(request:HostRequest): Promise<unknown> {
  if (typeof request.path !== 'string' || !request.path.startsWith('/') || request.path.startsWith('//')
      || /[\\\u0000-\u001f]/.test(request.path) || !['GET','POST','PUT','PATCH','DELETE','HEAD'].includes(request.method)) {
    throw new Error('허용되지 않은 편집기 요청입니다.');
  }
  if (!transport) throw new Error('와카 작업 연결이 필요합니다. 기존 작업 화면에서 다시 열어 주세요.');
  const active=transport;
  const response=await active(request);
  if(active!==transport)throw new Error('작업 연결이 바뀌어 이전 응답을 적용하지 않았습니다.');
  return response;
}
